import React from 'react';
import { styles } from '../TitleSection.css';
import { Tracker } from '../../Tracking';
import { useNavigate } from '../../PlatformFunctionality';

export type ArtistLinkProps = {
  artist: string;
};

export const ArtistLink = ({ artist }: ArtistLinkProps) => {
  const navigate = useNavigate();
  const artistLinkPath = `/search?query=${artist.toUpperCase()}&page=1&hitsPerPage=36&Artist=${artist.toUpperCase()}&Category=CD&Category=Vinyl`;

  const handleArtistLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    Tracker.trackCustomEvent({
      event: 'artistSearchClick',
      group: 'site search',
      category: 'search',
      value: artist,
    });
    navigate(event.currentTarget.href);
  };

  return (
    <div className={`${styles.container} ${styles.artistLinkContainer}`}>
      <a className={styles.artistLink} href={artistLinkPath} onClick={handleArtistLinkClick}>
        {artist}
      </a>
    </div>
  );
};
